import type {BalconyDoorCartItem, Dimension, WindowCartItem} from '@/graphql/types';

export const isApprovedForEmergencyExit = (item: Dimension | undefined, type: string) => {
	if (!item) return false;
	if (type === 'sidehengslet' && item.width > 75 && item.height > 98) return true;
	if (type === 'toppsving' && item.width > 108 && item.height > 112) return true;
	return false;
};

export const roundToTwoDecimals = (value: number): number => {
	return Math.round(value * 100) / 100;
};

export const formatItemForDataLayer = (
	item: WindowCartItem | BalconyDoorCartItem,
	selectedSupplier = '',
) => {
	const isWindow = 'windowType' in item;

	const slug = isWindow ? item.windowType.slug : item.balconyDoorType.slug;
	const category = isWindow ? 'Vinduer' : 'Balkongdører';

	const price = selectedSupplier
		? (item.supplierPrices?.find((sup) => sup?.supplier?.id === selectedSupplier)?.price ?? 0)
		: Math.min(
				...(item.supplierPrices?.map((p) => p.price).filter((price) => price !== -1) || [
					0,
				]),
			);

	const additions = [
		item.material.value,
		item.uValue.value,
		item.color.value,
		isWindow ? item.windowBar.value : item.bar.value,
		item.glassLayer.value,
		isWindow ? item.windowHandle.value : item.handle.value,
		isWindow ? item.windowVent.value : item.parapetHeight.value,
		item.glassTypes.map((type) => type.value),
	];

	const baseItem = {
		item_id: `${slug}_${item.dimension.slug}`,
		item_name: `${slug} ${item.dimension.slug} cm`,
		item_category: category,
		item_variant: additions.join(', '),
		price: price ? roundToTwoDecimals(price / item.count / 100 / 1.25) : undefined,
		quantity: item.count,
	};

	return isWindow
		? {
				...baseItem,
				window_material: item.material.value,
				window_glass: item.glassLayer.value,
				window_function_glass: item.glassTypes.map((type) => type.value).join(', '),
				window_color: item.color.value,
				window_bars: item.windowBar.value,
				window_handle: item.windowHandle.value,
				window_vents: item.windowVent.value,
			}
		: {
				...baseItem,
				window_material: item.material.value,
				window_glass: item.glassLayer.value,
				window_function_glass: item.glassTypes.map((type) => type.value).join(', '),
				window_color: item.color.value,
				window_bars: item.bar.value,
				window_handle: item.handle.value,
				window_parapet: item.parapetHeight.value ? item.parapetHeight.value : '0cm',
			};
};

export const getItemAdditions = (item: WindowCartItem | BalconyDoorCartItem): string => {
	const isWindow = 'windowType' in item;

	const additions = [
		item.material.value,
		item.uValue.value,
		item.color.value,
		isWindow ? item.windowBar.value : item.bar.value,
		item.glassLayer.value,
		isWindow ? item.windowHandle.value : item.handle.value,
		isWindow ? item.windowVent.value : item.parapetHeight.value,
		...item.glassTypes.map((type) => type.value),
	];

	return additions.filter(Boolean).join(', ');
};
